import { useTranslation } from "react-i18next";

import Label from "@components/form/Label";
import TextInput from "@components/form/TextInput";
import { formatDateInput } from "@utils/formatDate";
import { useAllAccountingPeriods } from "@hooks/query/useAllAccountingPeriods";

type TimestampInputProps = {
  id?: string;
  level1ResourceId: string;
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
};

const TimestampInput: React.FunctionComponent<TimestampInputProps> = ({
  id,
  level1ResourceId,
  label,
  value,
  onChange,
  required = false,
}) => {
  const { t } = useTranslation();

  const { data: accountingPeriod = {}, isLoading } = useAllAccountingPeriods({
    params: {
      isActive: true,
      level1ResourceId,
    },
    options: {
      enabled: Boolean(level1ResourceId),
      select: (res: any) => res?.[0],
    },
  });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Label htmlFor={id}>{label ?? t("common.effective_date")}</Label>
      <TextInput
        type="date"
        id={id}
        min={formatDateInput(new Date(accountingPeriod?.periodStart))}
        max={formatDateInput(new Date(accountingPeriod?.periodEnd))}
        value={formatDateInput(new Date(value))}
        onChange={onChange}
        required={required}
      />
    </>
  );
};

export default TimestampInput;
